export const quoteResultURL = (quoteId) => {
  const url = "/quote/result?quote=" + quoteId
  return url
}
